export default __webpack_public_path__ + "static/media/logo.2de0bcda.png";